<template>
  <img
    class="main_layout_bg sm-hide in_active"
    :src="`/images/games/${currentGameSlug}/banner_bg.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
  />
  <Meta
    name="og:image"
    :content="`https://boostingmarket.com/images/og-images/${currentGameSlug}-og.png?v=11`"
  />
  <Meta
    name="twitter:image"
    :content="`https://boostingmarket.com/images/og-images/${currentGameSlug}-og.png?v=11`"
  />

  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GameBanner />
    <h4 class="t-white title-h4 font-family-1 f-w-600">
      {{ $t("boosters.title") }}
    </h4>
    <div class="boosters_card_grid">
      <GameBoosterCard
        v-for="(gameBooster, i) in boosters"
        :key="gameBooster"
        :id="gameBooster.id"
        :image="gameBooster.avatar"
        :language="
          gameBooster.languages?.length > 0 ? gameBooster.languages[0] : null
        "
        :username="gameBooster.username"
        :rank="
          gameBooster?.game_ranks?.length > 0
            ? gameBooster.game_ranks[0]?.image_dark
            : ''
        "
        :rating="gameBooster.reviews_score"
        :orders="gameBooster.reviews_count"
        :is-online="gameBooster.online === 1"
        :tier="gameBooster?.rank?.image"
        :to="`/booster/${gameBooster?.slug}`"
      />
    </div>
    <div class="d-flex-row">
      <button
        class="primary outlined-color regular-m font-family-1 full-width max-width-180px large b-radius-6"
        @click.stop="onPageChange"
        v-if="loadMore"
      >
        Load More
      </button>
    </div>
  </div>
</template>

<script setup>
import GameBanner from "~/components/banners/GameBanner.vue";
import GameBoosterCard from "~/components/cards/GameBoosterCard.vue";
import { ref, watch } from "vue";
definePageMeta({
  layout: "default",
  pageInfo: {
    name: "boosters-game-page",
  },
});

const boosters = ref([]);
const params = ref({
  count: 5,
  page: 1,
});
const totalPage = ref(1);
const loadMore = ref(false);
// HOOKS
const { currentGameSlug } = useGameComposable();
const { t } = useI18n();

const { getLocale, getAuthHeaders } = useFunctions();
const { public: publicConfig } = useRuntimeConfig();
const headers = getAuthHeaders();
const gameStore = useGameStore();
const router = useRouter();
const route = router.currentRoute;

useHead({
  meta: [
    { name: "title", content: t(`${currentGameSlug}.meta_title`) },
    { name: "description", content: t(`${currentGameSlug}.description`) },
  ],
});

const mmoGames = ["world-of-warcraft-boost"];
const gameSlug = currentGameSlug;
let path = "get-game";
if (mmoGames.includes(gameSlug)) {
  path = "get-mmo-game";
}

const { data: response, error } = await useApiFetch(
  `/api/${path}/${gameSlug}`,
  {
    method: "post",
    fetchKey: `get-game-${gameSlug}`,
    body: {
      params: ["servers", "platforms", "roles", "faqs", "boosters"],
      locale: getLocale(),
      gameSlug: gameSlug,
    },
    initialCache: false,
  }
);

if (error.value?.data) {
  throw createError({
    statusCode: "404",
    statusMessage: "Not Found",
  });
}

if (response.value?.data) {
  useSeoMeta({
    title: response.value?.data?.meta_title,
    description: response.value?.data?.description,
  });
}

const fetchData = async () => {
  try {
    const { data } = await useApiPost("/api/get-boosters", {
      method: "POST",
      body: {
        game: currentGameSlug,
        params: [
          "game_ranks",
          "languages",
          "reviews_score_and_count",
          "online_sort",
        ],
        count: params.value.count, //default 10
        page: params.value.page, //default 1
      },
    });

    if (data?.boosters) {
      boosters.value = [...boosters.value, ...data?.boosters];
      totalPage.value = Math.ceil(data?.total_count / params.value.count);
      loadMore.value = data?.load_more;
    }
  } catch (error) {
    console.log(error);
  }
};

await fetchData();
const onPageChange = () => {
  params.value.page = params.value.page + 1;
  fetchData();
};
addCanonicalLink(route.value.fullPath);

onNuxtReady(() => {});
</script>
